export const AGORA_APP_ID = process.env.VUE_APP_AGORA_KEY
